import React, { useState, useEffect } from 'react';
import { func, string, array } from 'prop-types';
import { useIntl } from 'react-intl';
import MultiselectCheckbox from '@hmhco/multiselect-checkbox/src/MultiselectCheckbox';

// TODO: replace with real API data
const orgs = [
  {
    name: 'Springfield Elementary',
    addressCity: 'Springfield',
    addressStreet: '123 Main St',
    addressZip: '62701',
  },
  {
    name: 'Shelbyville Middle School',
    addressCity: 'Shelbyville',
    addressStreet: '456 Oak Ave',
    addressZip: '62565',
  },
  {
    name: 'Capital City High School',
    addressCity: 'Capital City',
    addressStreet: '789 Elm Rd',
    addressZip: '62702',
  },
];

const SchoolAssociationField = ({
  selectedSchools,
  handleChange,
  errorMessageId,
}) => {
  const { formatMessage } = useIntl();

  const [selectedOptions, setSelectedOptions] = useState(selectedSchools || []);

  useEffect(() => {
    setSelectedOptions(selectedSchools || []);
  }, [selectedSchools]);

  return (
    <MultiselectCheckbox
      allOptions={orgs}
      selectedOptions={selectedOptions}
      setSelectedOptions={newOptions => {
        setSelectedOptions(newOptions);
        handleChange(newOptions);
      }}
      placeholder={formatMessage({
        id: 'earlyAccess.createUser.placeholder.schoolAssociation',
      })}
      actionButtonText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.apply',
      })}
      resetButtonText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.clear',
      })}
      singleOptionSelectedText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.single',
      })}
      multipleOptionsSelectedText={formatMessage({
        id: 'earlyAccess.createUser.schoolAssociation.multiple',
      })}
      getOptionLabel={option => option.name || ''}
      getOptionKey={option => option.name || ''}
      formLabelText={formatMessage({
        id: 'earlyAccess.createUser.label.schoolAssociation',
      })}
      formLabelId="schoolAssociation"
      required
      error={Boolean(errorMessageId)}
      formHelperText={
        errorMessageId ? formatMessage({ id: errorMessageId }) : ''
      }
    />
  );
};

SchoolAssociationField.propTypes = {
  selectedSchools: array,
  handleChange: func.isRequired,
  errorMessageId: string,
};

export default SchoolAssociationField;
